
// Base64データからimgタグのsrc urlを取得する
export function getFileSrcToBase64 (fileData, fileName) {
  if (fileName && fileData) {
    let fileType = 'jpeg'
    let extension = fileName.split('.').slice(-1)[0]
    if (extension.toLowerCase() === 'png') fileType = 'png'
    return 'data:image/' + fileType + ';base64,' + fileData
  }
  return ''
}

export function toBlob (base64, mimeCtype) {
  // 日本語の文字化けに対処するためBOMを作成する。
  let bom = new Uint8Array([0xEF, 0xBB, 0xBF])

  let bin = atob(base64.replace(/^.*,/, ''))
  let buffer = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i)
  }
  // Blobを作成
  let blob = ''
  try {
    blob = new Blob([bom, buffer.buffer], {type: mimeCtype})
  } catch (e) {
    return false
  }
  return blob
}



// WEBPACK FOOTER //
// ./src/utils/ImageHelper.js